import { useFeatureFlag } from '@agentnet/feature-flags';
import { EmptyState } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { KBLinks } from 'features/constants';
import { ProfileContext, ProfileContextInterface } from 'hooks/ProfileContext';
import React, { useContext, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import PageHeader from 'ui-kit/components/headers/PageHeader';
import ContentContainer from 'ui-kit/components/utility/ContentContainer';
import { Pay_Manual_Only, Pay_Rights } from 'utilities/constants/activity-rights';
import { FeatureFlag } from 'utilities/constants/launch-darkly-flags';
import AutopayEmptyIcon from './Icons/AutopayEmptyIcon';

const useStyles = makeStyles(() =>
  createStyles({
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '80px',
    },
  }),
);

const AutopayServices = () => {
  const classes = useStyles();
  const profileCtx: ProfileContextInterface = useContext(ProfileContext) ?? {};
  const { userFirm, profile } = profileCtx;
  const isAutopayEnabled = useFeatureFlag(FeatureFlag.SHOW_AUTOPAY, true);

  const hideBilling = useMemo(() => {
    const payRights =
      Boolean(profile?.activityRights?.find((rights: any) => rights.ActivityRightId === Pay_Rights)) ||
      Boolean(profile?.activityRights?.find((rights: any) => rights.ActivityRightId === Pay_Manual_Only));
    return !payRights;
  }, [profile?.activityRights]);

  if (hideBilling || !userFirm?.firmId || !isAutopayEnabled.ready) {
    return null;
  }

  if (!isAutopayEnabled.value) {
    return <Redirect to="/admin/billing" />;
  }

  return (
    <ContentContainer>
      <PageHeader
        title="Autopay Services"
        subtitle="Manage your autopay services below – view current payment methods and reassign services to different payment methods as needed."
        menuItems={[
          {
            label: 'Knowledge Base',
            link: KBLinks.billing,
          },
        ]}
        divider={false}
      />
      <EmptyState
        icon={<AutopayEmptyIcon />}
        className={classes.emptyState}
        headerText="No Services with Autopay Activated"
        descriptionText="You don't have any services currently using autopay. To explore available services and turn on autopay, go to Integrations & Add-Ons"
      />
    </ContentContainer>
  );
};

export default AutopayServices;
